import { render } from "./SummaryMetric.vue?vue&type=template&id=117a87d0&scoped=true"
import script from "./SummaryMetric.vue?vue&type=script&lang=js"
export * from "./SummaryMetric.vue?vue&type=script&lang=js"

import "./SummaryMetric.vue?vue&type=style&index=0&id=117a87d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117a87d0"]])

export default __exports__